import React, { useRef, useMemo, useState } from 'react';
import useIntersectionLoadMore from '@gp/hooks/useIntersectionLoadMore';

const PAGE_SIZE = 5;

export default function useLoadMoreUpdates(props: {
  pageContainer?: React.RefObject<HTMLElement | null>;
  loadingContainer?: React.RefObject<HTMLElement | null>;
  userIsAbleSee?: boolean;
  segmentValue?: string;
  contentLoading?: boolean;
  dataList?: any[];
}) {
  const { pageContainer, loadingContainer, userIsAbleSee, segmentValue, contentLoading, dataList } = props;

  const loadingMore = useRef(false);

  const [visibleLength, setVisibleLength] = useState(PAGE_SIZE);

  const intersectionObserverDeps = useMemo<React.DependencyList>(
    () => [userIsAbleSee, segmentValue, contentLoading, dataList],
    [userIsAbleSee, segmentValue, contentLoading, dataList],
  );

  const dataListNew = useMemo<any[]>(() => {
    if (!Array.isArray(dataList) || !dataList.length) return [];
    return dataList.slice(0, Math.min(visibleLength, dataList.length));
  }, [visibleLength, dataList]);

  const setAllVisible = () => {
    setVisibleLength(dataList?.length || 0);
  };

  useIntersectionLoadMore({
    container: pageContainer,
    loadingContainer,
    onLoadMore: (stopObserver) => {
      if (loadingMore.current) return;
      loadingMore.current = true;
      setTimeout(() => {
        const dataListLength = dataList?.length || 0;
        const visibleLengthTmp = Math.min(visibleLength + PAGE_SIZE, dataListLength);
        setVisibleLength(visibleLengthTmp);
        if (visibleLengthTmp >= dataListLength) {
          stopObserver?.();
        }
        loadingMore.current = false;
      }, 600);
    },
    deps: intersectionObserverDeps,
  });

  return { visibleLength, dataListNew, setAllVisible };
}
